import Roles from 'constant/role';
import LoginVerificationOptions from 'constant/loginVerifcationOptions';
import UserStatus from 'constant/userStatus';
import { fullName } from 'utils/name';

export function isUserOnboarded(user) {
  if (!user) return false;
  return (
    (user.role !== Roles.END_USER && user.role !== Roles.VERIFIER) ||
    Boolean(user.onBoarded)
  );
}

export function isVerifiedUser(user) {
  return user?.status?.userVerificationStatus === UserStatus.VERIFIED;
}

export function hasLinkedEnterprise(user) {
  return user?.linkedEnterprises?.length > 0;
}

// Verification outlives an unlink, so a verified client keeps the full menu.
export function hasFullClientAccess(user) {
  return isVerifiedUser(user) || hasLinkedEnterprise(user);
}

export function isUserWithout2FA(user) {
  if (!user) return true;
  return (
    !isUserOnboarded(user) ||
    user.role === Roles.WUNA_ADMIN ||
    user.loginMethods?.length === 0
  );
}

export function isUserWithoutPin(user) {
  if (!user) return true;
  return (
    (user.role !== Roles.END_USER && user.role !== Roles.VERIFIER) ||
    !user.loginMethods?.includes(LoginVerificationOptions.PIN_CODE)
  );
}

// Mirrors the API's pause-unpause policy.
const PAUSABLE_MEMBER_ROLES = Object.freeze({
  [Roles.ENTERPRISE_USER]: [Roles.END_USER, Roles.VERIFIER],
  [Roles.VERIFIER]: [Roles.END_USER],
});

export function canPauseMember(viewerRole, memberRole) {
  return Boolean(PAUSABLE_MEMBER_ROLES[viewerRole]?.includes(memberRole));
}

export function accountStatusChangedMessage(user) {
  const name = fullName(user?.name);
  return user?.status?.userStatus === UserStatus.PAUSED
    ? `${name}'s account has been disabled. They no longer have access to the app.`
    : `${name}'s account has been enabled and they can sign in again.`;
}

export function getRoleUserFriendlyTitle(user) {
  if (!user) return <div />;
  return (
    <div style={{ textAlign: 'center', fontSize: '20px', color: 'white' }}>
      {user.role === Roles.VERIFIER ? (
        <span>{user?.enterprise?.name || 'WUNA+'} Verifier</span>
      ) : user.role === Roles.ENTERPRISE_USER ? (
        <span>{user?.enterprise?.name || 'WUNA+'} Privacy Officer</span>
      ) : user.role === Roles.THIRD_PARTY ? (
        <span>{user?.enterprise?.name || 'WUNA ID'} Verifier</span>
      ) : (
        <span></span>
      )}
    </div>
  );
}

export const identificationOptions = [
  { value: 'aboriginal', label: 'Aboriginal Descent' },
  { value: 'torres', label: 'Torres Strait Islander Descent' },
  {
    value: 'both',
    label: 'Both - Aboriginal and Torres Strait Islander Descent',
  },
  { value: 'other', label: 'Other Indigenous Descent' },
  { value: 'nonIndigenous', label: 'Non-Indigenous Australian' },
  { value: 'uncertain', label: 'Uncertain' },
];
